// extracted by mini-css-extract-plugin
module.exports = {"form":"AddNewProducer_form__3Jied"};